/**
 * Injects the real Walls.io widget once consent is given.
 */

function loadWalls() {
  const stub = document.getElementById('wallsio-script-stub');
  if (!stub) {
    return;
  }

  const real = document.createElement('script');
  real.async = true;
  real.src = stub.getAttribute('data-src');

  // Copy all data-* attributes except data-src
  Array.from(stub.attributes).forEach(attr => {
    if (attr.name.startsWith('data-') && attr.name !== 'data-src') {
      real.setAttribute(attr.name, attr.value);
    }
  });

  // Hide placeholder only once the real widget loads
  real.onload = function () {
    const ph = document.getElementById('wallsio-placeholder');
    if (ph) {
      ph.style.display = 'none';
    }
  };

  stub.parentNode.insertBefore(real, stub.nextSibling);
  stub.remove();
}

document.addEventListener('DOMContentLoaded', () => {

  // Yes (this time): inject for this page load only
  let yes_button = document.getElementById('wallsio-yes');
  if (yes_button) {
    yes_button.addEventListener('click', loadWalls);
  }

  // Always: persist consent, then inject
  let always_button = document.getElementById('wallsio-always');
  if (always_button) {
    always_button.addEventListener('click', () => {
      if (window.klaro && klaro.getManager) {
        const mgr = klaro.getManager();
        mgr.updateConsent('wallsio', true);
        mgr.saveAndApplyConsents();
      }
      loadWalls();
    });
  }
});
